import type { AgentMcpIntegration, AgentMcpToolMap } from "./agentMcpTypes";

export class NoOpAgentMcpIntegration implements AgentMcpIntegration {
  async prepareMcpTools(): Promise<AgentMcpToolMap> {
    return new Map();
  }
}
